import { useState, type ChangeEvent } from "react";
import { FaChevronRight } from "react-icons/fa6";
import { Sheet } from "react-modal-sheet";

import ISO6391 from "iso-639-1";

import { Field } from "shared/ui/field";
import { SearchInput } from "shared/ui/search-input";

import { Option } from "./option";

type Props = { code: string; onSelect: (code: string) => void };

const languages = ISO6391.getAllCodes().map((code) => ({
  code,
  name: ISO6391.getName(code),
  nativeName: ISO6391.getNativeName(code),
}));

export const SelectLanguage = (props: Props) => {
  const { code, onSelect } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
  };

  const filteredLanguages = languages.filter(({ name, nativeName }) => {
    return (
      name.toLowerCase().includes(search.toLowerCase()) ||
      nativeName.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <>
      <Field
        as="button"
        className="cursor-pointer flex-row hover:brightness-125"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <div className="inline-flex text-lg leading-5.5 font-medium tracking-[0.4px] text-white">
          Language
        </div>

        <div className="text-pale-grey ml-auto flex items-center gap-x-1">
          <span>{ISO6391.getName(code)}</span>

          <FaChevronRight className="size-4" />
        </div>
      </Field>
      <Sheet
        unstyled
        detent="full"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <Sheet.Container className="bg-black px-4 pt-5">
          <Sheet.Header className="flex flex-col pb-5">
            <h3 className="mb-3 flex text-[26px] leading-6 font-semibold tracking-[0.45px]">
              Language
            </h3>
            <div className="mt-3 flex grow items-center gap-x-3">
              <SearchInput
                value={search}
                onChange={handleSearchChange}
                onCancel={() => setSearch("")}
              />

              <button
                className="text-clear-blue inline-flex cursor-pointer leading-5.5 tracking-[0.4px] transition-colors hover:brightness-110"
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </button>
            </div>
          </Sheet.Header>
          <Sheet.Content className="flex grow flex-col">
            <div className="text-natural-grey flex text-[13px] leading-4.5 tracking-[0.08%]">
              SUPPORTED LANGUAGES
            </div>
            <ul className="bg-oil mt-2 flex flex-col overflow-hidden rounded-[10px]">
              {filteredLanguages.map((language) => {
                return (
                  <Option
                    key={language.code}
                    title={language.name}
                    description={language.nativeName}
                    isActive={code === language.code}
                    onClick={() => {
                      setIsOpen(false);
                      onSelect(language.code);
                    }}
                  />
                );
              })}
            </ul>
          </Sheet.Content>
        </Sheet.Container>
      </Sheet>
    </>
  );
};
